module.exports = __webpack_public_path__ + "static/coatofarms-bad1e7d03e0aedbdd12411728321cf97.jpg";